<style scoped lang="scss">
.breads{
  overflow:auto;line-height: 48px;margin-bottom:  20px;
}
.desc{
  font-size: 16px;text-indent: 0;margin-bottom:20px;
}
.compose-type{
    background: #f6fafd;
    padding-bottom: 80px;
    margin-top: 100px;
}
@media screen and (max-width: 640px) {
  .compose-type {
    margin-top: 50px;
    padding-bottom: 30px;
  }
}
</style>
<style scoped>
@import url("../../assets/sanger.css");
@import url("../../assets/service.css");
</style>
<template>
  <!--  基因合成-DNA片段合成 -->
  <div class="wrap wrap-tec">
    <router-view></router-view>
    <!-- banner -->
    <gene-top-banner :smallTitle="smallTitle" :bigTitle="bigTitle"></gene-top-banner>
    <section v-if="!$route.meta.invisibles">
      <!-- 导航 -->
      <div class="breads container">
        <bread></bread>
      </div>
      <!-- 概述 -->
      <div class="container">
        <p class="desc">擎科生物提供简单基因的合成、改造等片段基因合成，适用于多个基因构建体的高通量筛选等应用。</p>
      </div>
      <!-- 服务内容 -->
      <div class="container">
        <en-title title="服务内容" enTitle="Service Details"></en-title>
        <gene-detail-table :tableColumn="tableColumn" :tableData="tableData" :tableSpanMethod="tableSpanMethod"></gene-detail-table>
      </div>
      <!-- 交付结果 -->
      <div class="container">
        <en-title title="交付结果" enTitle="Deliverables"></en-title>
        <gene-deliverables :products="products" :reports="reports"></gene-deliverables>
      </div>
      <!-- 订购与咨询 -->
      <div class="container">
          <new-consult type="gene" :typeList="['orderOnline','telePhone','download','email']"></new-consult>
      </div>
    </section>
  </div>
</template>
<script>
import bread from "@/components/bread"
import GeneTopBanner from "./gene-components/geneTopBanner"
import EnTitle from '@/components/EnTitle'
import GeneAdvantages from './gene-components/geneAdvantages'
import GeneDetailTable from './gene-components/geneDetailTable'
import GeneDeliverables from './gene-components/geneDeliverables'
export default {
  components:{
    bread, 
    GeneTopBanner,
    EnTitle,
    GeneAdvantages,
    GeneDetailTable,
    GeneDeliverables,
  },
  data () {
    return {
      smallTitle:'全基因组合成',
      bigTitle:'DNA片段合成',
      tableColumn:[
        {
          label:'基因长度',
          prop:'geneLength',
        },
        {
          label:'生产周期（自然日）',
          prop:'productionCycle',
        }
      ],
      tableData:[
        {
          geneLength:'< 1.2 kb',
          productionCycle:'2 - 3',
        },
      ],
      products:'冻干粉 DNA 一管 ( 约500 ng/ 管 )',
    }
  },
  methods: {
    tableSpanMethod({ row, column, rowIndex, columnIndex }){   

    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/products/DNA_fragments_page.vue